import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchOrganization(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/fetch_organization/${organization_id}`
    );
  },
  fetchOrganizationCertifications(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/fetch_organization_certifications/${organization_id}`
    );
  },
  fetchCertificationReviews(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/fetch_certification_reviews/${organization_id}`
    );
  },
  fetchOrganizationCertification(
    agro_exporter_id,
    organization_id,
    organization_certification_id
  ) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/fetch_organization_certification/${organization_id}/${organization_certification_id}`
    );
  },
  fetchCertifications(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/fetch_certifications/${organization_id}`
    );
  },
  create(agro_exporter_id, organization_id, organization_certification) {
    let formData = new FormData();
    formData.append(
      "organization_certification[certification_code]",
      organization_certification.certification_code
    );
    formData.append(
      "organization_certification[expiration_date]",
      organization_certification.expiration_date
    );
    formData.append(
      "organization_certification[certification_id]",
      organization_certification.certification_id
    );
    formData.append(
      "organization_certification[renewal_date]",
      organization_certification.renewal_date
    );
    formData.append(
      "organization_certification[active]",
      organization_certification.active
    );
    if (organization_certification.certificate_file) {
      formData.append(
        "organization_certification[certificate_file]",
        organization_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/create/${organization_id}`,
      formData
    );
  },
  update(
    agro_exporter_id,
    organization_id,
    organization_certification_id,
    organization_certification
  ) {
    let formData = new FormData();
    formData.append(
      "organization_certification[certification_code]",
      organization_certification.certification_code
    );
    formData.append(
      "organization_certification[expiration_date]",
      organization_certification.expiration_date
    );
    formData.append(
      "organization_certification[certification_id]",
      organization_certification.certification_id
    );
    formData.append(
      "organization_certification[renewal_date]",
      organization_certification.renewal_date
    );
    formData.append(
      "organization_certification[active]",
      organization_certification.active
    );
    if (organization_certification.certificate_file) {
      formData.append(
        "organization_certification[certificate_file]",
        organization_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/update/${organization_id}/${organization_certification_id}`,
      formData
    );
  },
  destroy(agro_exporter_id, organization_id, organization_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/destroy/${organization_id}/${organization_certification_id}`
    );
  },
  downloadCertificateFile(agro_exporter_id, organization_id, organization_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_organization_certification/${agro_exporter_id}/download_certificate_file/${organization_id}/${organization_certification_id}`,
      { responseType: "blob" }
    );
  }
};
